<template>
  <div
    class="border-neutral-lighter border-solid border-b border-t-0 border-l-0 border-r-0 mb-2"
  >
    <div class="flex items-center">
      <h5 class="font-semibold text-primary flex-1">{{ folder.name }} </h5>
      <div v-if="!isPortalLogin && !folder.isTrash" class="px-3">
        <MButton outline @click="$emit('edit')">
          {{ $t('edit') }}
        </MButton>
      </div>
    </div>
    <div class="my-2">
      {{ folder.description }}
    </div>
    <div v-if="!isPortalLogin" class="my-4 flex">
      <div class="flex-1">
        <div class="flex items-center">
          <MIcon name="file-alt" class="text-neutral-light mx-2" size="lg" />
          <div class="flex flex-col">
            <small class="text-neutral-light">
              {{ $t('read_permission') }}
            </small>
            <div>
              {{ readPermission }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isPortalLogin" class="flex-1">
        <div class="flex items-center">
          <MIcon name="file-edit" class="text-neutral-light mx-2" size="lg" />
          <div class="flex flex-col">
            <small class="text-neutral-light">
              {{ $t('write_permission') }}
            </small>
            <div>
              {{ writePermission }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import { readPermissions, writePermissions } from './helpers/utils'

export default {
  name: 'FolderDetail',
  props: { folder: { type: Object, required: true } },
  computed: {
    ...authComputed,
    readPermission() {
      return (
        readPermissions().find((p) => p.key === this.folder.readPermission) ||
        {}
      ).text
    },
    writePermission() {
      return (
        writePermissions().find((p) => p.key === this.folder.writePermission) ||
        {}
      ).text
    },
  },
}
</script>
